<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4
              v-if="!areThereFilters"
              class="mb-0"
            >
              {{ getLength(organizations) }}
            </h4>
            <h4
              v-else
              class="mb-0"
            >
              {{ totalRows }} of {{ getLength(organizations) }}
            </h4>
            <p>Organizations</p>
            <b-button variant="primary" @click="addOrganization">Add New Organization</b-button>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By Organization Name, Street, City or State</p>
            <b-input-group>
              <b-form-input v-model="filter.nameText" @input="handleFilterChange" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter.nameText" @click="clearFilter">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn
            v-on:click.prevent="resetFilters"
          >
            Clear Filters
          </b-btn>

          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-row>
                <b-col sm="3">
                  <b-form-group label="County / Parish">
                    <b-form-select
                      class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="selectedCountyOrParish"
                      :style="{ width: '150px' }"
                      :options="countyOrParishOptions"
                    >
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="State">
                    <b-form-select
                      class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="selectedState"
                      :style="{ width: '150px' }"
                      :options="[{ value: null, text: 'Choose...' }, ...states]"
                    >
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                v-on:click.prevent="updateSearchResults"
                type="submit"
                variant="primary"
                class="px-4"
              >
                Update Results
              </b-button>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>

    <br />

    <b-row>
      <b-col sm="12">
        <b-card>
          <h2 v-show="!finishedLoading" class="u-padding-bottom-20">Loading, please wait ...</h2>
          <pulse-loader :loading="!finishedLoading" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
          <b-table
            v-show="finishedLoading"
            :filter="filter"
            :filter-function="searchFilter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="true"
            :fixed="true"
            responsive="sm"
            :items="organizations"
            :fields="getTableFields()"
            :per-page="20"
            :current-page="currentPage"
          >

            <div slot="title" class slot-scope="item">
              <b-link @click="goOrganization(item.item.id)">
                <span class>{{item.value}}</span>
              </b-link>
            </div>
            <div slot="b_confirmed" class slot-scope="item">
              <span :v-if="item.value !== ''" class>{{item.value}}</span>
            </div>
          </b-table>
          <b-pagination
            :total-rows="getLength(organizations)"
            prev-text="Prev"
            next-text="Next"
            :current-page="currentPage"
            v-model="currentPage"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>



<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrganizationList',
  components: {},
  computed: {
    ...mapGetters({
      parishes: 'getLAParishData',
      counties: 'getCountyData',
      states: 'getStateAndAbbrev',
      organizations: 'getAllOrganizations'
    }),
    countyOrParishOptions () {
      const options = [
        { value: null, text: 'Choose...' }
      ]
      let countyOrParishes = []
      switch (this.selectedState) {
        case 'TX':
          countyOrParishes = this.counties
          break
        case 'LA':
          countyOrParishes = this.parishes
          break
        default:
          break
      }
      return options.concat(countyOrParishes)
    },
    areThereFilters () {
      return this.filter.nameText ||
        this.filter.countyOrParish ||
        this.filter.state
    }
  },
  data: function () {
    return {
      spinnerColor: '#489AAC',
      spinnerSize: '50px',
      finishedLoading: false,
      modalInfo: { title: '', content: '' },
      selected: 'Month',
      totalRows: 0,
      currentPage: 1,
      filter: {
        nameText: sessionStorage.getItem('organizationSearchFilter') || '',
        countyOrParish: null,
        state: null
      },
      showDataTable: false,

      // Fields for the Data Table
      supportBackup: true,
      supportNested: true,
      query: { limit: 10 },
      data: [],
      total: 0,
      Pagination: true,

      // Fields for the bootstrap table
      selectedCountyOrParish: null,
      selectedState: null,
      sortBy: 'timestamp',
      sortDesc: true,
      sortDirection: 'desc',
      tableFields: [
        {
          key: 'title',
          label: 'Organization Name',
          sortable: true
        },
        {
          key: 'mailingStreet',
          label: 'Street',
          class: '',
          sortable: true
        },
        {
          key: 'mailingCity',
          label: 'City',
          class: '',
          sortable: true
        },
        {
          key: 'county',
          label: 'County / Parish',
          class: '',
          sortable: true
        },
        {
          key: 'mailingStateAbbreviation',
          label: 'State',
          class: '',
          sortable: true
        }
      ]
    }
  },
  created: function () {
    this.searchOrganizations()
  },
  methods: {
    searchOrganizations () {
      this.$store.dispatch('getOrganizations', {}).then(response => {
        this.finishedLoading = true
      })
    },
    searchFilter (originalRecord) {
      let foundMatch = false
      let foundStateMatch = true
      let foundCountyOrParishMatch = true
      const stringSearches = [
        'title',
        'mailingStreet',
        'mailingCity',
        'county',
        'mailingStateAbbreviation'
      ]

      if (this.filter.state) {
        foundStateMatch = this.filter.state === originalRecord['mailingStateAbbreviation']
      }

      if (this.filter.countyOrParish) {
        foundCountyOrParishMatch = this.filter.countyOrParish === originalRecord['county']
      }

      if (this.filter.nameText === null) {
        return foundStateMatch && foundCountyOrParishMatch
      }

      let filter = this.filter.nameText.toLowerCase()

      _.forEach(stringSearches, element => {
        let field = originalRecord[element]

        if (_.isString(field) && field !== '') {
          field = field.toLowerCase()
          if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
            foundMatch = true
          }
        }
      })

      return foundMatch && foundStateMatch && foundCountyOrParishMatch
    },
    getTableFields () {
      return this.tableFields
    },
    goOrganization (item) {
      if (item) {
        const path = '/admin/organizations/' + item
        this.$router.push({ path: path })
      }
    },
    addOrganization (item) {
      this.$router.push({ path: '/admin/organizations/add' })
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    getLength (items) {
      return items.length
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleFilterChange (value) {
      sessionStorage.setItem('organizationSearchFilter', value)
    },
    clearFilter (value) {
      this.filter.nameText = ''
      sessionStorage.setItem('organizationSearchFilter', '')
    },
    resetFilters () {
      this.selectedCountyOrParish = null
      this.selectedState = null
      this.updateSearchResults()
    },
    updateSearchResults () {
      this.filter.countyOrParish = this.selectedCountyOrParish
      this.filter.state = this.selectedState
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/Admin/OrganizationList.vue